module.exports = __webpack_public_path__ + "static/media/Facebook1.7c018803.svg";